export { default } from './AirBnBCarouselContainerMobile';
